export const StringResources = {
    Accept: 'Aceptar',
    DocumentDeliveries: 'Entregas documentales',
    ExpedientePackaging: 'Expedientes empaquetados',
    Active: 'Activo',
    IsTrdEnabled: 'TRD activa',
    ActuaComoRepresentanteQuestion: '¿Actúa cómo representante?',
    Address: 'Dirección',
    AllowEdit: 'Permitir editar',
    ApprovalComments: 'Observaciones de la aprobación',
    Approve: 'Aprobar',
    Review: 'Revisar',
    ArchivoX_EditNotification: 'Editar notificación',
    AssignmentByProfile: 'Asignación por perfil',
    AssignmentType: 'Tipo de asignación',
    AssociateContact: 'Asociar a contacto',
    AtencionPreferencial: 'Atención preferencial',
    AuthorizedRoles: 'Roles autorizados',
    Back: 'Volver',
    Barrio: 'Barrio',
    Cancel: 'Cancelar',
    CancelRequest: 'Cancelar solicitud',
    CertifiedMail: 'Correo certificado',
    City: 'Ciudad',
    Code: 'Código',
    Comments: 'Observaciones',
    CurrentSection: 'Subsección actual',
    CompanyName: 'Tipo de entidad',
    ContactType: 'Tipo de contacto',
    TipoSolicitante: 'Tipo de contacto',
    CopyActiveDocumentaryTypes: 'Copiar tipos documentales activos',
    CopyActiveFolders: 'Copiar carpetas activas',
    Country: 'País',
    DateOfBirth: 'Fecha de nacimiento',
    DecisionTable: 'Tabla de decisión',
    Default: 'Predeterminado',
    DefaultUser: 'Usuario predeterminado',
    Delete: 'Eliminar',
    Description: 'Descripción',
    Edit: 'Editar',
    Email: 'Correo electrónico',
    EndDate: 'Fecha fin',
    ExpedienteName: 'Título del expediente',
    ExpedienteNumber: 'Número expediente',
    Finish: 'Finalizar',
    FinishTurno: 'Finalizar turno',
    FirstCall: 'Primer llamado',
    Fondo: 'Fondo',
    Gender: 'Género',
    GrupoEtnido: 'Grupo étnico',
    IdentificationNumber: 'Número de identificación',
    IdentificationType: 'Tipo de identificación',
    InformationRequest: 'Solicitar información',
    InformationRequestHistory: 'Solicitudes de información',
    LastName: 'Apellido',
    LevelOfSchooling: 'Nivel de escolaridad',
    ModoRecepcion: 'Modo de recepción',
    ModuleName: 'Nombre del módulo',
    MAS: 'Módulo de atención y servicio',
    MyApprovals: 'Mis aprobaciones',
    Error: 'Error',
    ApprovalPending: 'Pendiente por aprobar',
    Pending: 'Pendiente',
    Completed: 'Completo',
    MyRequests: 'Mis solicitudes',
    Name: 'Nombre',
    Names: 'Nombres',
    New: 'Nuevo',
    Next: 'Siguiente',
    NextTurno: 'Siguiente turno',
    No: 'No',
    NumeroReferencia: 'Número de referencia',
    Permissions: 'Permisos',
    Position: 'Cargo',
    PostalCode: 'Código postal',
    PreferenciaRespuesta: 'Preferencia de la respuesta',
    Prefix: 'Prefijo',
    ProcesoX_AllowUploadDocumentUsingActivityInstance: 'Permitir cargar documentos por medio de la instancia de proceso',
    ProcesoX_ImportProject: 'Importar proyecto',
    Import: 'Importar',
    Export: 'Exportar',
    Simulate: 'Simular',
    ProcesoX_ShowErrorsSummaryInDialog: 'Mostrar resumen de errores en cuadro de dialogo',
    ProcessInitiatorUser: 'Usuario que inicia el flujo',
    Profession: 'Profesión u oficio',
    Profile: 'Perfil',
    PuntoRadicacion: 'Punto de Radicación',
    ReadAllDocumentaryTypes: 'Leer todos los tipos documentales',
    ReadSpecificDocumentaryTypes: 'Leer tipos documentales especificos',
    ReadWriteAllDocumentaryTypes: 'Leer, crear y editar todos los tipos documentales',
    ReadWriteSpecificDocumentaryTypes: 'Leer, crear y editar tipos documentales especificos',
    Reconnected: 'Reconectar',
    RequestComments: 'Observaciones de la solicitud',
    ReturnedComments: 'Comentarios de la devolución',
    Responsible: 'Responsable',
    ResponsibleUser: 'Usuario Responsable',
    Role: 'Rol',
    Roles: 'Roles',
    Seccion: 'Sección',
    SecondCall: 'Segundo llamado',
    Serie: 'Serie',
    SeriePertenencia: 'Serie a la que pertenece',
    ShowAll: 'Mostrar todo',
    StartDate: 'Fecha inicio',
    Subfondo: 'Subfondo',
    Subject: 'Asunto',
    Subseccion: 'Subsección',
    Subserie: 'Subserie',
    ThirdCall: 'Tercer llamado',
    TipoRadicado: 'Tipo de radicado',
    Tramite: 'Trámite',
    Variable: 'Variable',
    Version: 'Versión',
    VersionTrd: 'Versión TRD',
    View: 'Ver',
    Yes: 'Si',
    DigitalSignature: 'Firma digital',
    ElectronicSignature: 'Firma electrónica',
    HandwrittenSignature: 'Firma manuscrita',
    History: 'Histórico',
    SendSurveyEmail: 'Enviar encuesta a Email',
    SendSurveyDevice: 'Enviar encuesta a Dispositivo'
};
